<template>
  <v-dialog
    value="true"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    :persistent="$vuetify.breakpoint.lgAndUp"
    transition="dialog-bottom-transition"
    :max-width="$vuetify.breakpoint.lgAndUp ? '800' : undefined"
    dark
    style="padding-top: env(safe-area-inset-top);"
    content-class="rounded-xl"
  >
    <v-card style="width: 100vw; overflow-x: hidden;" class="rounded-xl">
      <v-toolbar
        fixed
        :color="template.colors.primary"
        :style="`color: ${template.colors.inline_primary_text};`"
        style="
          padding-top: env(safe-area-inset-top);
          height: 80px + env(safe-area-inset-top);
        "
      >
        <v-toolbar-title>
          Veranstaltung hinzufügen
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          icon
          :color="template.colors.inline_primary_text"
          @click="closing()"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-row justify="center" class="mt-4" v-if="teams.length != 0">
          <v-col cols="10" lg="8" class="px-2">
            <v-select
              filled
              rounded
              v-model="v.art"
              :items="arten"
              label="Art der Veranstaltung"
              hide-details
              :rules="[rules.required]"
            ></v-select>
          </v-col>
          <v-col cols="10" lg="8" class="px-2" v-if="user.data.sportstaetten && v.art != 'Auswärtsspiel'">
            <v-select
              v-model="v.sportstaette"
              :rules="[rules.required]"
              :items="user.data.sportstaetten"
              item-text="name"
              item-value="name"
              filled
              rounded
              hide-details
              label="Sportstätte"
            ></v-select>
          </v-col>
          <v-col
            cols="10"
            lg="8"
            class="px-2"
            v-if="v.art == 'Wettkampf' || v.art == 'Versammlung'"
          >
            <v-text-field
              v-model="v.name"
              :rules="[rules.required]"
              filled
              rounded
              hide-details
              label="Name der Veranstaltung"
            ></v-text-field>
          </v-col>
          <v-col
            cols="10"
            lg="8"
            class="px-2"
            v-if="teamsloaded && v.art != 'Wettkampf'"
          >
            <v-select
              v-model="v.mannschaft"
              :items="teams"
              item-text="name"
              item-value="name"
              :rules="
                v.art != 'Versammlung' || user.data.rolle == 'Trainer'
                  ? [rules.required]
                  : undefined
              "
              filled
              rounded
              hide-details
              :label="
                v.art == 'Versammlung' && user.data.rolle != 'Trainer'
                  ? 'Mannschaft (optional)'
                  : v.art == 'Meisterschaftsspiel' ||
                    v.art == 'Freundschaftsspiel' ||
                    v.art == 'Pokalspiel'
                  ? 'Heimmannschaft'
                  : 'Mannschaft'
              "
            ></v-select>
          </v-col>
          <v-col
            cols="10"
            lg="8"
            class="px-2"
            v-if="
              v.art == 'Meisterschaftsspiel' ||
              v.art == 'Freundschaftsspiel' ||
              v.art == 'Auswärtsspiel' ||
              v.art == 'Pokalspiel'
            "
          >
            <v-text-field
              :rules="[rules.required]"
              v-model="v.gastmannschaft"
              filled
              rounded
              hide-details
              :label="v.art == 'Auswärtsspiel' ? 'Gastgebende Mannschaft' : 'Gastmannschaft'"
            ></v-text-field>
          </v-col>
          <v-col cols="10" lg="8" class="px-2">
            <v-dialog
              ref="beginndatum"
              v-model="beginndatum"
              :return-value.sync="v.beginn.datum"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="parse_datum(v.beginn.datum)"
                  label="Datum (Beginn)"
                  :rules="[rules.required]"
                  filled
                  rounded
                  hide-details
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="de"
                first-day-of-week="1"
                v-model="v.beginn.datum"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :color="template.colors.primary"
                  @click="beginndatum = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                  text
                  :color="template.colors.primary"
                  :style="`color: ${template.colors.inline_primary_text};`"
                  @click="
                    $refs.beginndatum.save(v.beginn.datum)
                    v.ende.datum = v.beginn.datum
                  "
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="10" lg="8" class="px-2">
            <v-dialog
              class="mb-4"
              ref="beginnuhrzeit"
              v-model="beginnuhrzeit"
              :return-value.sync="v.beginn.uhrzeit"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="v.beginn.uhrzeit"
                  :rules="[rules.required]"
                  label="Uhrzeit (Beginn)"
                  filled
                  rounded
                  hide-details
                  prepend-icon="mdi-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                format="24hr"
                v-model="v.beginn.uhrzeit"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :color="template.colors.primary"
                  @click="beginnuhrzeit = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                  text
                  :color="template.colors.primary"
                  :style="`color: ${template.colors.inline_primary_text};`"
                  @click="$refs.beginnuhrzeit.save(v.beginn.uhrzeit)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col
            cols="10"
            lg="8"
            class="px-2"
            v-if="v.art == 'Wettkampf' || v.art == 'Versammlung'"
          >
            <v-dialog
              ref="endedatum"
              v-model="endedatum"
              :return-value.sync="v.ende.datum"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="parse_datum(v.ende.datum)"
                  label="Datum (Ende)"
                  :rules="[rules.required]"
                  filled
                  rounded
                  hide-details
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="de"
                first-day-of-week="1"
                v-model="v.ende.datum"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :color="template.colors.primary"
                  @click="endedatum = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                  text
                  :color="template.colors.primary"
                  :style="`color: ${template.colors.inline_primary_text};`"
                  @click="$refs.endedatum.save(v.ende.datum)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="10" lg="8" class="px-2">
            <v-dialog
              class="mb-4"
              ref="endeuhrzeit"
              v-model="endeuhrzeit"
              :return-value.sync="v.ende.uhrzeit"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="v.ende.uhrzeit"
                  label="Uhrzeit (Ende)"
                  :rules="[rules.required]"
                  filled
                  rounded
                  hide-details
                  prepend-icon="mdi-clock"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker format="24hr" v-model="v.ende.uhrzeit" scrollable>
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :color="template.colors.primary"
                  @click="endeuhrzeit = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                  text
                  :color="template.colors.primary"
                  :style="`color: ${template.colors.inline_primary_text};`"
                  @click="$refs.endeuhrzeit.save(v.ende.uhrzeit)"
                >
                  OK
                </v-btn>
              </v-time-picker>
            </v-dialog>
          </v-col>
          <v-col cols="10" lg="8" class="px-2">
            <v-divider class="my-3" v-if="v.art == 'Training'"></v-divider>
            <v-switch
              v-model="repeat"
              inset
              :color="template.colors.primary"
              v-if="v.art == 'Training'"
              label="Wiederkehrende Veranstaltung"
            ></v-switch>
            <v-select
              filled
              rounded
              v-model="repeat_days"
              :items="wochentage"
              item-text="name"
              item-value="id"
              label="Jeden ..."
              v-if="repeat"
              multiple
            ></v-select>
            <v-dialog
              ref="bisdatum"
              v-model="bisdatum"
              :return-value.sync="repeat_datum"
              persistent
              width="290px"
              v-if="repeat"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :value="parse_datum(repeat_datum)"
                  label="Bis Datum"
                  filled
                  rounded
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="de"
                first-day-of-week="1"
                v-model="repeat_datum"
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  :color="template.colors.primary"
                  @click="bisdatum = false"
                >
                  Abbrechen
                </v-btn>
                <v-btn
                  text
                  :color="template.colors.primary"
                  :style="`color: ${template.colors.inline_primary_text};`"
                  @click="$refs.bisdatum.save(repeat_datum)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <v-select
              filled
              rounded
              label="Nation erforderlich?"
              v-if="v.art == 'Wettkampf'"
              :items="[
                { text: 'Ja', value: true },
                { text: 'Nein', value: false },
              ]"
              v-model="v.nation_required"
            ></v-select>
            <v-btn
              class="my-4"
              block
              rounded
              large
              :color="template.colors.primary"
              :style="`color: ${template.colors.inline_primary_text};`"
              :disabled="!check_valid()"
              @click="create()"
              :loading="creating"
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              Hinzufügen
            </v-btn>
            <v-btn
              class="my-4"
              block
              large
              outlined
              rounded
              :color="template.colors.primary"
              @click="closing()"
            >
              Abbrechen
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row
        justify="center"
        class="mt-4"
        style="height: 70vh;"
        v-if="teams.length == 0 && teamsloaded"
      >
        <v-col cols="10" lg="8" align-self="center">
          <h2>
            Es sieht so aus als hättest du noch kein Team angelegt. Bevor du
            eine Veranstaltung erstellen kannst, musst du ein Team erstellen.
          </h2>
        </v-col>
        <v-col cols="10" lg="8" align-self="center">
          <v-btn color="success" large block to="/teams">
            Jetzt Team erstellen
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
//import firebase from '../../../firebaseConfig'
import { mapGetters } from 'vuex'

export default {
  name: 'Veranstaltung-erstellen',
  data() {
    return {
      v: {
        art: '',
        name: '',
        mannschaft: '',
        heimmannschaft: '',
        gastmannschaft: '',
        beginn: {
          datum: '',
          uhrzeit: '',
        },
        ende: {
          datum: '',
          uhrzeit: '',
        },
        maxzuschauer: 300,
        sportstaette: '',
        nation_required: false,
      },
      wochentage: [
        {
          id: 1,
          name: 'Montag',
        },
        {
          id: 2,
          name: 'Dienstag',
        },
        {
          id: 3,
          name: 'Mittwoch',
        },
        {
          id: 4,
          name: 'Donnerstag',
        },
        {
          id: 5,
          name: 'Freitag',
        },
        {
          id: 6,
          name: 'Samstag',
        },
        {
          id: 0,
          name: 'Sonntag',
        },
      ],
      teams: [],
      teamsloaded: false,
      beginndatum: false,
      beginnuhrzeit: false,
      endedatum: false,
      creating: false,
      repeat: false,
      repeat_days: '',
      repeat_datum: '',
      repeat_datum_beginn: '',
      bisdatum: false,
      valid: false,
      vondatum: false,
      endeuhrzeit: false,
      arten: [],
      rules: {
        required: (value) => !!value || 'Bitte gebe diese Daten ein',
      },
      counter: 0,
    }
  },
  mounted() {
    this.arten = this.template.var.arten
    if (this.user.data.rolle == 'Vorstand') {
      firebase
        .firestore()
        .collection('User')
        .doc(this.user.data.uid)
        .collection('Team')
        .orderBy('name')
        .get()
        .then((docRef) => {
          docRef.forEach((doc) => {
            this.teams.push(doc.data())
            var id = this.teams.length - 1
            this.teams[id].id = doc.id
          })
          this.teamsloaded = true
        })
        .catch((error) => {
          console.log(error)
        })
    } else if (this.user.data.rolle == 'Trainer') {
      firebase
        .firestore()
        .collection('User')
        .doc(this.user.data.uid)
        .collection('Team')
        .where('name', 'in', this.user.data.team)
        .get()
        .then((docRef) => {
          docRef.forEach((doc) => {
            this.teams.push(doc.data())
            var id = this.teams.length - 1
            this.teams[id].id = doc.id
          })
          this.teamsloaded = true
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  computed: {
    ...mapGetters({
      user: 'user',
      template: 'template',
    }),
  },
  methods: {
    closing() {
      this.$emit('closing', true)
    },
    parse_datum(datum) {
      if (datum) {
        var d = datum.split('-')
        return d[2] + '.' + d[1] + '.' + d[0]
      } else {
        return datum
      }
    },
    addNull(val) {
      if (val >= 10) {
        return val
      } else {
        return '0' + val
      }
    },
    check_valid() {
      if (
        this.v.art == 'Training' &&
        ((this.repeat && this.repeat_days.length > 0 && this.repeat_datum) ||
          !this.repeat) &&
        this.v.beginn.datum &&
        this.v.beginn.uhrzeit &&
        this.v.ende.uhrzeit &&
        this.v.maxzuschauer &&
        this.v.mannschaft &&
        ((this.user.data.sportstaetten && this.v.sportstaette) ||
          !this.user.data.sportstaetten)
      ) {
        return true
      } else if (
        this.v.art != 'Training' &&
        this.v.art != 'Wettkampf' &&
        this.v.beginn.datum &&
        this.v.beginn.uhrzeit &&
        this.v.maxzuschauer &&
        this.v.mannschaft &&
        this.v.gastmannschaft &&
        ((this.user.data.sportstaetten && this.v.sportstaette) ||
          !this.user.data.sportstaetten)
      ) {
        return true
      } else if (
        this.v.art == 'Auswärtsspiel' &&
        this.v.beginn.datum &&
        this.v.beginn.uhrzeit &&
        this.v.mannschaft &&
        this.v.gastmannschaft
      ) {
        return true
      } else if (
        this.v.art == 'Wettkampf' &&
        this.v.beginn.datum &&
        this.v.beginn.uhrzeit &&
        this.v.ende.uhrzeit &&
        this.v.maxzuschauer &&
        this.v.name &&
        ((this.user.data.sportstaetten && this.v.sportstaette) ||
          !this.user.data.sportstaetten)
      ) {
        return true
      } else if (
        this.v.art == 'Versammlung' &&
        (this.user.data.rolle == 'Vorstand' || this.v.mannschaft) &&
        this.v.beginn.datum &&
        this.v.beginn.uhrzeit &&
        this.v.ende.uhrzeit &&
        this.v.maxzuschauer &&
        this.v.name &&
        ((this.user.data.sportstaetten && this.v.sportstaette) ||
          !this.user.data.sportstaetten)
      ) {
        return true
      } else {
        return false
      }
    },
    async create() {
      if (this.v.art == 'Training' && this.repeat) {
        if (this.v.beginn.datum) {
          this.creating = true
          var loop = true
          var repeat = ''
          var loop_date = new Date(this.v.beginn.datum)
          var loop_date_str =
            loop_date.getFullYear() +
            '-' +
            this.addNull(parseInt(loop_date.getMonth()) + 1) +
            '-' +
            this.addNull(parseInt(loop_date.getDate()))
          while (loop == true) {
            if (this.repeat_days.includes(loop_date.getDay())) {
              await firebase
                .firestore()
                .collection('User')
                .doc(this.user.data.uid)
                .collection('Veranstaltung')
                .add({
                  art: this.v.art,
                  name: this.v.art == 'Wettkampf' ? this.v.name.trim() : '',
                  mannschaft:
                    this.v.art != 'Wettkampf' ? this.v.mannschaft : '',
                  gastmannschaft:
                    this.v.art == 'Freundschaftsspiel' ||
                    this.v.art == 'Meisterschaftsspiel' ||
                    this.v.art == 'Auswärtsspiel' ||
                    this.v.art == 'Pokalspiel'
                      ? this.v.gastmannschaft
                      : '',
                  beginn: {
                    datum: loop_date_str,
                    uhrzeit: this.v.beginn.uhrzeit,
                  },
                  ende: {
                    datum: loop_date_str,
                    uhrzeit: this.v.ende.uhrzeit,
                  },
                  day: loop_date.getDay(),
                  maxzuschauer: this.v.maxzuschauer,
                  sportstaette: this.v.sportstaette,
                  repeat: repeat ? repeat : '',
                  nation_required: this.v.nation_required
                    ? this.v.nation_required
                    : '',
                })
                .then((doc) => {
                  if (!repeat) {
                    repeat = {
                      id: doc.id,
                      days: this.repeat_days,
                      beginndatum: this.repeat_datum_beginn,
                      endedatum: this.repeat_datum,
                    }
                    firebase
                      .firestore()
                      .collection('User')
                      .doc(this.user.data.uid)
                      .collection('Veranstaltung')
                      .doc(doc.id)
                      .update({
                        repeat: {
                          id: doc.id,
                          days: this.repeat_days,
                          beginndatum: this.repeat_datum_beginn,
                          endedatum: this.repeat_datum,
                        },
                      })
                  }
                })
            }
            loop_date.setDate(loop_date.getDate() + 1)
            loop_date_str =
              loop_date.getFullYear() +
              '-' +
              this.addNull(parseInt(loop_date.getMonth()) + 1) +
              '-' +
              this.addNull(parseInt(loop_date.getDate()))
            if (loop_date_str == this.repeat_datum) {
              loop = false
              if (this.repeat_days.includes(loop_date.getDay())) {
                await firebase
                  .firestore()
                  .collection('User')
                  .doc(this.user.data.uid)
                  .collection('Veranstaltung')
                  .add({
                    art: this.v.art,
                    name:
                      this.v.art == 'Wettkampf' || this.v.art == 'Versammlung'
                        ? this.v.name
                        : '',
                    mannschaft:
                      this.v.art != 'Wettkampf' ? this.v.mannschaft : '',
                    gastmannschaft:
                      this.v.art == 'Freundschaftsspiel' ||
                      this.v.art == 'Meisterschaftsspiel' ||
                      this.v.art == 'Auswärtsspiel' ||
                      this.v.art == 'Pokalspiel'
                        ? this.v.gastmannschaft
                        : '',
                    beginn: {
                      datum: loop_date_str,
                      uhrzeit: this.v.beginn.uhrzeit,
                    },
                    ende: {
                      datum: loop_date_str,
                      uhrzeit: this.v.ende.uhrzeit,
                    },
                    day: loop_date.getDay(),
                    maxzuschauer: this.v.maxzuschauer,
                    sportstaette: this.v.sportstaette,
                    repeat: repeat ? repeat : '',
                  })
              }
              this.creating = false
              this.closing()
            }
          }
        }
      } else {
        firebase
          .firestore()
          .collection('User')
          .doc(this.user.data.uid)
          .collection('Veranstaltung')
          .add({
            art: this.v.art,
            name:
              this.v.art == 'Wettkampf' || this.v.art == 'Versammlung'
                ? this.v.name
                : '',
            mannschaft: this.v.art != 'Wettkampf' ? this.v.mannschaft : '',
            gastmannschaft:
              this.v.art == 'Freundschaftsspiel' ||
              this.v.art == 'Meisterschaftsspiel' ||
              this.v.art == 'Auswärtsspiel' ||
              this.v.art == 'Pokalspiel'
                ? this.v.gastmannschaft
                : '',
            beginn: this.v.beginn,
            ende: this.v.ende,
            maxzuschauer: this.v.maxzuschauer,
            sportstaette: this.v.sportstaette,
          })
          .then((doc) => {
            this.creating = false
            this.closing()
          })
          .catch((error) => {
            this.creating = false
            console.log('Es ist ein Fehler aufgetreten!', error)
          })
      }
    },
  },
}
</script>
